import { Request } from '../';

const goodsString = `
      mid
      pid
      category
      status
      statusOrder
      createTime
      updateTime
      applyTime
      expireTime
      showTime
      hideTime
      isAutoShowHide
      confirmTime
      deliveryTime
      labelsDesc
      labelsValue
      isSearch
      nameSpu
      iconSpu
      descSpu
      isSearch
      priority
      sid
      uid
      spu
      maxOrder
      maxUser
      isCurrency
      isMix
      isBundle
      isVirtual
      transportFee
      transport
      feeBelong
      sellSpu
      priceFrom
      priceTo
      priceOldFrom
      priceOldTo
      priceCostFrom
      priceCostTo
      numLabel
      maxUser
      maxOrder
      transport
      transportFee
      feeBelong
      scoreNum
      scoreTotal
      scoreAvg
      stockAll
      isMeCollect
      weight
      isMemberDis
      isLimitBuy
      notRefund
      barCode
      media
      shareDesc
      feature
      limitBuyCate
      lifeNumBuy
      cycleFrequency
      cycleNumBuy
      buttonText
      minBuy
      longitude
      latitude
      location
      areaKey
      minLevel
      contactName
      contactPhone
      hadBought
      good {
        payMethod
        payMethodAuto
        payMethodByLevel
        payMethodExt {
          level
          payMethod
        }
      }
      store {
        name
        nameAlias
        key
        sid
        icon
        isPay
        deposit
        address
        location
        latitude
        location
        numFans
        description
        phone
      }
      goodArray {
        code
        rebateMap
        rebateAuto
        sku
        stock
        gid
        sid
        uid
        spu
        priceOld
        priceCost
        price
        numSellDay
        numSellMonth
        isAttach
        nameSku
        name
        iconSku
        descSku
        offerRate
        offerPrice
        createTime
        updateTime
        payMethodAuto
        payMethodByLevel
        payMethodExt {
          level
          payMethod
        }
        labelArray {
          labelTxt
          labelDesc
          labelTag
          labelIndex
        }
        payMethod
        numCanUse
        applyTime
        expireTime
        applySecond
        expireSecond
        priceAdviceFrom
        priceAdviceTo
        stockDay
        stockMonth
        stockDayRest
        stockMonthRest
        weight
        barCode
      }
      post {
        content {
          content
          gallery
        }
      }
      `;
const orderIndexList = `orderIndexList(query: $queryOrderList) {
          data {
            xid
            status
          }
          meta {
            limit
            page
            count
            num
          }
        }`;

// 首页广告图
export const themeAds = async () => {
  const gql = `query themeAds() {
    pub {
      themeAds {
        cate
        key
        sid
        limit
        icon
        text
        store {
          sid
          icon
        }
        brand {
          bid
          icon
          name
        }
        goods {
          mid
          pid
          category
          status
          nameSpu
          iconSpu
        }
      }
    }
  }`;
  return (await Request.request(gql, {}, 'mall', '首页广告')).pub.themeAds;
};

/**
 * 交易信息
 * @param payload
 * @returns {Promise<*>}
 */
export const mallUser = async payload => {
  const query = `query mallUser {
  me {
    detail {
      isBusiness
      sidDefault
      orderCount
      createTime
      updateTime
    }
  }
}`;
  return (await Request.request(query, payload, 'mall', '交易信息')).me.detail;
};

/**
 * 该商品下单列表
 * @param payload
 * @returns {Promise<*>}
 */
export const otherOrderList = async payload => {
  const query = `query otherOrderList($mid: String!, $query: FormQuery) {
  pub {
    goods(mid: $mid) {
      mid
      pid
      category
      otherOrderList(query: $query) {
        data{
          oid
          xid
          parent
          uidBuy
          uidSell
          sid
          gid
          serialId
          comment
          userBuy {
            uid
            nickname
            profile {
              icon
              name
              sex
            }
          }
        }
        meta{
          page
          count
        }
      }
    }
  }
}`;
  return (await Request.request(query, payload, 'mall', '该商品下单列表')).pub.goods.otherOrderList;
};

/**
 * 商品列表
 * @param payload
 * @returns {Promise<*>}
 */
export const queryGoodsList = async payload => {
  const query = `query goodsList($query: FormQuery, $queryScore: FormQuery, $queryBrands: FormQuery, $queryChildBrands: FormQuery, $queryOrderList: FormQuery) {
  pub {
    goodsList(query: $query) {
      data {
        ${goodsString}
        ${orderIndexList}
        stockArray {
          stock
          labelTxt
          labelTag
          isThis
        }
        categoryInfo {
          key
          name
          parentObj {
            key
            name
            parentObj {
              key
              name
            }
          }
        }
        activityArr {
          aid
          uid
          sid
          applyTime
          expireTime
          createTime
          status
          name
          isMinDiscount
          minPriority
          note
          isRealCheck
          isPhoneCheck
          numReceive
          minCost
          minDiscount
          couponStoreArray {
            cid
            sid
            cate
            scene
            status
            rate
            name
            property
            numRelease
            numReceived
            amount
            numCanUse
            numUsed
            numUsedUp
            numUsedOn
            validDay
            applyTime
            expireTime
            createTime
            updateTime
            note
            comment
            minCost
            isReceive
          }
        }
        scoreList(query: $queryScore) {
          data {
            oid
            uid
            sid
            pid
            spu
            sku
            scoreGood
            scoreService
            scoreShipper
            post {
              content {
                title
                content
                gallery
                galleryText
              }
            }
            userInfo {
              username
              nickname
              profile {
                name
                realName
                realIcon
                sex
                address
                country
                province
                city
                district
              }
            }
          }
          meta {
            limit
            page
            num
            count
            skip
            sort
          }
        }
        goodsBrands(query: $queryBrands) {
          data {
            bid
            sid
            name
            icon
            status
            parent
            createTime
            updateTime
            priority
            limitOrder
            childList(query: $queryChildBrands) {
              data {
                bid
                sid
                name
                icon
                status
                parent
                createTime
                updateTime
                priority
                limitOrder
              }
              meta {
                limit
                page
                num
                count
                skip
                sort
              }
            }
            parentData {
              bid
              name
              icon
              status
              createTime
              updateTime
            }
          }
          meta {
            limit
            page
            num
            count
            skip
            sort
          }
        }
      }
      meta {
        limit
        page
        num
        count
        skip
        sort
      }
    }
  }
}`;
  return (await Request.request(query, payload, 'mall', '商品列表')).pub.goodsList;
};

/**
 * 商品详情
 * @param payload
 * @returns {*}
 */
export const queryGoodsDetail = async payload => {
  const gql = `query goodsDetail($mid: String!, $choice: [String!], $queryBrand: FormQuery, $queryScore: FormQuery, $queryOrderList: FormQuery) {
  pub {
    goods(mid: $mid) {
      ${goodsString}
      ${orderIndexList}
      stockArray(choice: $choice) {
        stock
        labelTxt
        labelTag
        isThis
        labelDesc
        labelIndex
        good {
          code
          iconSku
          gid
          priceOld
          price
          stock
          nameSku
          name
          offerRate
          payMethod
          payMethodAuto
          payMethodByLevel
          payMethodExt {
            level
            payMethod
          }
        }
      }
      categoryInfo {
        key
        name
        parentObj {
          key
          name
          parentObj {
            key
            name
          }
        }
      }
      goodsBrands(query: $queryBrand) {
        data {
          bid
          sid
          name
          parent
          key
          icon
          status
          createTime
          parentData {
            bid
            sid
            name
            parent
            key
            icon
            status
            createTime
          }
          childList(query: $queryBrand) {
            data {
              bid
              sid
              name
              parent
              key
              icon
              status
              createTime
            }
          }
        }
        meta {
          limit
          page
          count
          num
        }
      }
      activityArr {
        aid
        uid
        sid
        applyTime
        expireTime
        createTime
        status
        name
        isMinDiscount
        minPriority
        note
        isRealCheck
        isPhoneCheck
        numReceive
        minCost
        minDiscount
        couponStoreArray {
          cid
          sid
          cate
          scene
          status
          rate
          name
          property
          numRelease
          numReceived
          amount
          numCanUse
          numUsed
          numUsedUp
          numUsedOn
          validDay
          applyTime
          expireTime
          createTime
          updateTime
          note
          comment
          minCost
          isReceive
        }
      }
      scoreList(query: $queryScore) {
        data {
          oid
          uid
          sid
          pid
          spu
          sku
          scoreGood
          scoreService
          scoreShipper
          post {
            content {
              title
              content
              gallery
              galleryText
            }
          }
          userInfo {
            username
            nickname
            profile {
              name
              realName
              realIcon
              sex
              address
              country
              province
              city
              district
            }
          }
        }
        meta {
          limit
          page
          num
          count
          skip
          sort
        }
      }
    }
  }
}`;
  return (await Request.request(gql, payload, 'mall', '商品详情')).pub.goods;
};
// 购物车列表
export const queryCartList = async payload => {
  const query = `query cartListByStore {
    me {
      cartListByStore {
        acc
        cid
        uid
        gid
        sid
        storeName
        name
        price
        numBuy
        icon
        createTime
        goodDetail {
          gid
          nameSku
          iconSku
          stock
          price
          priceOld
          goodMeta {
            payMethod
          }
          goods {
            nameSpu
            mid
            iconSpu
            transport
            transportFee
            minBuy
            limitBuyCate
            isLimitBuy
            lifeNumBuy
            cycleNumBuy
          }
          payMethodAuto
          payMethodByLevel
          payMethodExt {
            level
            payMethod
          }
        }
      }
    }
  }`;
  return (await Request.request(query, payload, 'mall', '购物车列表')).me.cartListByStore;
};

// 加入购物车
export const addToCart = async payload => {
  const mutation = `mutation addToCart($form: [FormCart!]!) {
    meExec {
      newCartBunch(form: $form){
        acc
        name
        cid
      }
    }
  }`;
  return (await Request.request(mutation, payload, 'mall', '加入购物车')).meExec.newCartBunch;
};

// 删除购物车商品
export const delCartBunch = async payload => {
  const mutation = `mutation delCartBunch($form: [String!]!) {
    meExec {
      delCartBunch(form: $form)
    }
  }`;
  return (await Request.request(mutation, payload, 'mall', '删除购物车商品')).meExec.delCartBunch;
};

// 批量更新购物车
export const updateCartBunch = async params => {
  const gql = `mutation updateCartBunch($form: [UpdateCart!]!) {
    meEdit {
      updateCartBunch(form: $form) {
        gid
        numBuy
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '批量更新购物车')).meEdit.updateCartBunch;
};

// 批量创建订单
export const newOrderIndexBunch = async payload => {
  const mutation = `mutation newOrderIndexBunch($form: FormOrderBunch!) {
  meExec {
    newOrderIndexBunch(form: $form) {
      xid
      uid
      sid
      payMapBefore
      payMapAfter
      transportFee
      transport
      address {
        text
        name
        phone
        location
      }
      orderCouponArr {
        acc
        fid
        property
        useFloat
        couponUserInfo {
          cate
          amount
        }
      }
      storeArray {
        backInfo {
          xid
          category
        }
        transportFee
        amountDis
        payMapBefore
        payMapAfter
        amountDis
        transportFee
        note
        category
        serialID
        comment
        status
        store {
          name
          icon
          sid
        }
        orderInfo {
          oid
          xid
          numBuy
          note
          transport
          good {
            gid
            nameSku
            name
            iconSku
            price
            priceOld
            priceCost
            payMethod
            payMethodAuto
            payMethodByLevel
            payMethodExt {
              level
              payMethod
            }
            goods {
              nameSpu
              iconSpu
              transport
            }
          }
        }
      }
    }
  }
}`;
  return (await Request.request(mutation, payload, 'mall', '批量创建订单')).meExec.newOrderIndexBunch;
};

/**
 * 我的商家券列表
 * @param params
 * @returns {Promise<unknown>}
 */
export const fetchCouponUserList = async params => {
  const gql = `query couponUserList($query: FormQuery, $mid: String, $cate: String!) {
    me {
      couponUserList(query: $query, cate: $cate, mid: $mid) {
        data {
          cate
          isGoodsUsed
          numGoodsUsed
          property
          code {
            code
            expireTime
          }
          orderInfo {
            numBuy
            goodDetail {
              goods {
                nameSpu
                iconSpu
              }
              nameSku
              iconSku
            }
          }
          isGoodsUsed
          acc
          cid
          uid
          status
          isAvl
          amount
          balance
          numCanUse
          applyTime
          expireTime
          couponStore {
            comment
            isReceive
            minCost
            cid
            sid
            cate
            uid
            scene
            status
            rate
            property
            scene
            note
            name
            numRelease
            numReceived
            amount
            numCanUse
            numUsedUp
            numUsedOn
            validDay
            expireTime
            applyTime
            createTime
          }
        }
        meta {
          limit
          page
          count
          num
        }
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '我的商家券列表')).me.couponUserList;
};

/**
 * 券可用判断
 * @param params
 * @returns {Promise<unknown>}
 */
export const tryOrderCoupon = async params => {
  const gql = `query tryCoupon($form: FormOrderCouponTry!) {
  me {
    tryOrderCoupon(form: $form) {
      acc
      fid
      comment
      amount
      cate
      useFloat
      warnTxt
    }
  }
}`;
  return (await Request.request(gql, params, 'mall', '券可用判断')).me.tryOrderCoupon;
};

// 微信支付订单
export const payOrderByWeixin = async params => {
  const gql = `mutation payOrderIndexByWeixin($openId: String!, $xid: String!) {
    meExec {
      payOrderIndexByWeixin(openId: $openId, xid: $xid) {
        pid
        platform
        wfAcc
        orderPayMeta {
          oidList
          comment
        }
        createTime
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '微信支付订单')).meExec.payOrderIndexByWeixin;
};

// 支付订单
export const payOrderIndex = async params => {
  const gql = `mutation payOrderIndex($xid: String!) {
    meExec {
      payOrderIndex(xid: $xid) {
        pid
        xid
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '支付订单')).meExec.payOrderIndex;
};

/**
 * 标记已支付
 * @param params
 */
export const payClaim = async params => {
  const gql = `mutation payClaim($xid: String!, $isPay: Boolean) {
    meExec {
      payClaim(xid: $xid, isPay: $isPay) {
        xid
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '标记已支付')).meExec.payClaim;
};

// 商品分类列表
export const queryCategoryList = async payload => {
  const query = `query categoryList($query: FormQuery, $sid: String) {
  pub {
    categoryList(query:$query, sid: $sid) {
      data {
        sid
        key
        parent
        parentObj {
          parent
          icon
          isEnd
          status
          priority
          createTime
          updateTime
        }
        name
        icon
        priority
        childArray {
          key
          name
          icon
          parent
          parentObj {
            key
            name
            icon
          }
          childArray {
            key
            name
            icon
            parent
            parentObj {
              key
              name
              icon
            }
          }
        }
      }
      meta {
        limit
        page
        count
        num
      }
    }
  }
}`;
  return (await Request.request(query, payload, 'mall', '商品分类')).pub.categoryList;
};

const activityMapStruct = `aid
            cate
            tid
            kind
            createTime
            status
            isDelete
            priority
            numInit
            numCount
            numRemain
            minLevel
            maxJoin
            priceGood
            goodsInfo {
              ${goodsString}
            }`;

/**
 * 商城装修模板
 * @param params
 * @returns {Promise<*>}
 */
export const mallTemplateList = async params => {
  const gql = `query mallTemplateList($query: FormQuery) {
  pub {
    mallTemplateList(query: $query) {
      data {
        key
        status
        minLevel
        name
        content
      }
      meta {
        limit
        page
        count
        num
      }
    }
  }
}`;
  return (await Request.request(gql, params, 'mall', '商城装修模板')).pub.mallTemplateList;
};

/**
 * 商城装修模板默认
 * @param params
 * @returns {Promise<*>}
 */
export const mallTemplateAuto = async params => {
  const gql = `query mallTemplateAuto {
  pub {
    mallTemplate {
      key
      status
      minLevel
      name
      content
    }
  }
}`;
  return (await Request.request(gql, params, 'mall', '商城自动模板')).pub.mallTemplate;
};

// 活动列表
export const queryActivityList = async params => {
  const gql = `query activityList($query: FormQuery, $token: String, $queryActivityMap: FormQuery) {
    pub(token: $token) {
      activityList(query: $query) {
        data {
          isPhoneCheck
          isRealCheck
          aid
          uid
          applyTime
          expireTime
          status
          statusTime
          name
          createTime
          note
          cidList
          windows
          banners
          activityMapList(query: $queryActivityMap) {
            data {
              ${activityMapStruct}
            }
            meta {
              limit
              page
              count
              num
            }
          }
          storeList(query: { page:0, limit:100 }) {
            data {
              sid
              uid
              name
              key
              status
              icon
            }
            meta {
              limit
              page
              count
              num
            }
          }
          couponStoreList(query: { page:0, limit:100, keyJson: "{\\"status\\": 2}" }) {
            data {
              comment
              cid
              sid
              uid
              cate
              scene
              status
              rate
              name
              property
              numRelease
              numReceived
              amount
              numCanUse
              numUsed
              numUsedUp
              numUsedOn
              validDay
              applyTime
              expireTime
              note
              minCost
              isReceive
            }
            meta {
              page
              limit
              count
              num
            }
          }
        }
        meta {
          limit
          page
          count
          num
        }
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '活动列表')).pub.activityList;
};

// 领取商家券
export const newCouponUser = async params => {
  const gql = `mutation newCouponUser($cid: String!) {
    meExec {
      newCouponUser(cid: $cid) {
        acc
        cid
        uid
        status
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '领取商家券')).meExec.newCouponUser;
};

/**
 * 商品分组列表
 * @param params
 * @returns {Promise<*>}
 */
export const queryBrandList = async params => {
  const gql = `query brandList($query: FormQuery, $queryChild: FormQuery) {
  pub {
    brandList(query: $query) {
      data {
        bid
        name
        key
        icon
        status
        createTime
        priority
        limitOrder
        parent
        parentData {
          bid
          name
          key
          icon
          status
          createTime
          priority
          limitOrder
        }
        childList(query: $queryChild) {
          data {
            bid
            name
            key
            icon
            status
            createTime
            priority
            limitOrder
            parent
            parentData {
              bid
              name
              key
              icon
              status
              createTime
              priority
              limitOrder
            }
            childList(query: $queryChild) {
              data {
                bid
                name
                key
                icon
                status
                createTime
                priority
                limitOrder
                parent
                parentData {
                  bid
                  name
                  key
                  icon
                  status
                  createTime
                  priority
                  limitOrder
                }
                childList(query: $queryChild) {
                  data {
                    bid
                    name
                    key
                    icon
                    status
                    createTime
                    priority
                    limitOrder
                    parent
                    parentData {
                      bid
                      name
                      key
                      icon
                      status
                      createTime
                      priority
                      limitOrder
                    }
                  }
                  meta {
                    limit
                    page
                    count
                    num
                  }
                }
              }
              meta {
                limit
                page
                count
                num
              }
            }
          }
          meta {
            limit
            page
            count
            num
          }
        }
      }
      meta {
        limit
        page
        count
        num
      }
    }
  }
}`;
  return (await Request.request(gql, params, 'mall', '商品分组列表')).pub.brandList;
};

// 分成订单列表
export const sellOrderList = async params => {
  const gql = `query sellOrderList($query: FormQuery!) {
    me {
      orderList(query: $query) {
        data {
          oid
          createTime
          index
          uidSell
          uidBuy
          liveCate
          priceCost
          price
          profitAll
          status
          profitPlatform
          profitRetail
          order {
            oid
            priceOne
            numBuy
            priceAll
            good {
              nameSku
              name
              iconSku
              goods {
                nameSpu
                iconSpu
              }
            }
            userBuyInfo {
              nickname
              phone
              profile {
                name
                phone
                icon
              }
            }
          }
        }
        meta {
          count
          page
        }
      }
    }
  }`;
  return (await Request.request(gql, params, 'live', '分成订单列表')).me.orderList;
};

// 订单列表
export const orderList = async params => {
  const gql = `query getOrderList($query: FormQuery, $cate: String!) {
    me {
      orderIndexList(query: $query, cate: $cate) {
        meta {
          limit
          page
          count
          num
        }
        data {
          transport
          logisticInfo {
            pickInfo {
              name
              pid
              areaKey
              longitude
              latitude
              location
              applyTime
              applyTimeText
              createTime
              address
              contactName
              phone
              icon
              distance
            }
            xid
            transport
            status
            createTime
            pid
            code
            realName
            phone
            logisticCode
            shipperCode
            reason
            trace {
              acceptStation
              acceptTime
              acceptCate
              acceptUid
              acceptName
              acceptPhone
              acceptAreaKey
              acceptLongitude
              acceptLatitude
              acceptLocation
            }
          }
          takerInfo {
            isPayClaim
          }
          backInfo {
            xid
            serialID
            payMapAfter
            payMapBefore
            amountDis
            transportFee
          }
          storeInfo {
            couponPay
            couponCrossPay
          }
          amountDis
          transportFee
          address {
            name
            phone
            location
            text
          }
          amountDis
          userInfo {
            uid
            username
            profile {
              icon
              name
            }
          }
          comment
          storeArray{
            backInfo {
              xid
              category
            }
            transportFee
            amountDis
            payMapAfter
            payMapBefore
            store {
              icon
              name
            }
            storeInfo {
              couponPay
              couponCrossPay
            }
            parent
            status
            orderPayCash {
              platform
              receipt
              createTime
            }
            payMapBefore
            payMapAfter
            amountDis
            orderInfo {
              good {
                price
                stock
                priceOld
                nameSku
                name
              }
              statusPay
              xid
              orderMeta {
                rebateMap
                refundUser
                deliveryArray {
                  deliverCode
                  deliverCompany
                }
                unpaidMapAll
              }
              couponUserArr {
                acc
              }
              payTime
              sendTime
              dealTime
              storeDetail {
                name
                uid
                sid
                icon
                phone
                storeMeta {
                  comment
                }
              }
              serialId
              numBuy
              priceAll
              priceOne
              status
              goodDetail {
                nameSku
                applyTime
                expireTime
                gid
                status
                stock
                priceOld
                price
                goods {
                  ${goodsString}
                }
              }
              userBuy {
                uid
                nickname
                username
                phone
                profile {
                  name
                  icon
                  realName
                }
              }
              userSell {
                uid
                nickname
                username
                phone
                profile {
                  name
                  icon
                  realName
                }
              }
            }
            category
            xid
            createTime
            serialID
            oidList
            packArray {
              transport
              logisticInfo {
                pickInfo {
                  name
                  pid
                  areaKey
                  longitude
                  latitude
                  location
                  applyTime
                  applyTimeText
                  createTime
                  address
                  contactName
                  phone
                  icon
                  distance
                }
                xid
                transport
                status
                createTime
                pid
                code
                realName
                phone
                logisticCode
                shipperCode
                reason
                trace {
                  acceptStation
                  acceptTime
                  acceptCate
                  acceptUid
                  acceptName
                  acceptPhone
                  acceptAreaKey
                  acceptLongitude
                  acceptLatitude
                  acceptLocation
                }
              }
              parent
              status
              orderPayCash {
                platform
                receipt
                createTime
              }
              payMapBefore
              payMapAfter
              amountDis
              orderInfo {
                xid
                statusPay
                couponUserArr {
                  acc
                }
                payTime
                sendTime
                dealTime
                storeDetail {
                  name
                  uid
                  sid
                  icon
                  phone
                  storeMeta {
                    comment
                  }
                }
                serialId
                numBuy
                priceAll
                priceOne
                status
                goodDetail {
                  nameSku
                  applyTime
                  expireTime
                  gid
                  status
                  stock
                  priceOld
                  price
                  goods {
                    ${goodsString}
                  }
                }
                userBuy {
                  uid
                  nickname
                  username
                  phone
                  profile {
                    name
                    icon
                    realName
                  }
                }
                userSell {
                  uid
                  nickname
                  username
                  phone
                  profile {
                    name
                    icon
                    realName
                  }
                }
              }
              category
              xid
              createTime
              serialID
              oidList
            }
          }
          parent
          status
          orderPayCash {
            platform
            receipt
            createTime
          }
          payMapBefore
          payMapAfter
          amountDis
          orderInfo {
            scoreDetail {
              scoreGood
              scoreService
              scoreShipper
              oid
              sku
              spu
            }
            statusPay
            oid
            orderMeta {
              rebateMap
              refundUser
              deliveryArray {
                deliverCode
                deliverCompany
              }
              unpaidMapAll
            }
            good {
              nameSku
              name
              goods {
                ${goodsString}
              }
            }
            couponUserArr {
              acc
            }
            payTime
            sendTime
            dealTime
            storeDetail {
              name
              uid
              sid
              icon
              phone
              storeMeta {
                comment
              }
            }
            delivery {
              realName
              address
              phone
            }
            serialId
            numBuy
            priceAll
            priceOne
            status
            goodDetail {
              nameSku
              iconSku
              applyTime
              expireTime
              gid
              status
              stock
              priceOld
              price
              goods {
                ${goodsString}
              }
            }
            userBuy {
              uid
              nickname
              username
              phone
              profile {
                name
                icon
                realName
              }
            }
            userSell {
              uid
              nickname
              username
              phone
              profile {
                name
                icon
                realName
              }
            }
          }
          category
          xid
          parent
          createTime
          serialID
          oidList
        }
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '订单列表')).me.orderIndexList;
};

// 评价列表
export const getEvaList = async params => {
  const gql = `query getEvaList($mid: String!, $token: String, $query: FormQuery) {
  pub(token: $token) {
    goods(mid: $mid) {
      scoreList(query: $query) {
        data {
          createTime
          oid
          uid
          sid
          pid
          spu
          sku
          scoreGood
          scoreService
          scoreShipper
          orderDetail {
            good {
              nameSku
              name
            }
          }
          post {
            content {
              content
              gallery
            }
          }
          userInfo {
            nickname
            username
            phone
            profile {
              name
              icon
            }
          }
        }
        meta {
          limit
          page
          count
          num
        }
      }
    }
  }
}`;
  return (await Request.request(gql, params, 'mall', '评价列表')).pub.goods.scoreList;
};

// 订单评价
export const ensureScore = async params => {
  const gql = `mutation ensureScore($form: FormScore!,$oid: String!,$content:FormPostContent) {
    meExec {
      ensureScore(form: $form, oid: $oid,content: $content) {
        oid
        scoreGood
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '评价')).meExec.ensureScore;
};

/**
 * 快递物流信息
 * @param params
 * @returns {Promise<*>}
 */
export const getOrderDelivery = async params => {
  const gql = `query getOrderDelivery($shipper: String!, $logisticCode: String!) {
    me {
      getOrderDelivery(shipper: $shipper, logisticCode: $logisticCode) {
        logisticCode
        shipperCode
        shipperName
        state
        reason
        traces {
          acceptTime
          acceptStation
        }
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '快递物流信息')).me.getOrderDelivery;
};

// 申请售后
export const applyRefund = async params => {
  const gql = `mutation applyRefund($form: ApplyRefund!) {
    meEdit {
      applyRefund(form: $form) {
        xid
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '申请售后')).meEdit.applyRefund;
};

// 订单确认收货
export const dealOrderIndex = async params => {
  const gql = `mutation dealOrderIndex($xid: String!, $cate: String) {
    meExec {
      dealOrderIndex(xid: $xid, cate: $cate) {
        xid
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '订单确认收货')).meExec.dealOrderIndex;
};

// 取消订单
export const cancelOrder = async params => {
  const gql = `mutation cancelOrder($xid: String!) {
    meExec {
      cancelOrder(xid: $xid) {
        xid
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '取消订单')).meExec.cancelOrder;
};

// 新建收藏
export const newUserMap = async params => {
  const gql = `mutation newUserMap($form: FormUserMap!) {
    meExec {
      newUserMap(form: $form) {
        goods {
          mid
          nameSpu
        }
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '新建收藏')).meExec.newUserMap;
};

// 删除收藏
export const delUserMap = async params => {
  const gql = `mutation delUserMap($form: FormUserMap!) {
    meExec {
      delUserMap(form:$form)
    }
  }`;
  return (await Request.request(gql, params, 'mall', '删除收藏')).meExec.delUserMap;
};

// 收藏列表
export const userMapList = async params => {
  const gql = `query userMapList($query: FormQuery) {
    me {
      userMapList(query: $query) {
        data {
          uid
          tid
          cate
          comment
          createTime
          goods {
            ${goodsString}
          }
          store {
            name
            sid
            icon
          }
        }
        meta {
          limit
          page
          count
          num
        }
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '收藏列表')).me.userMapList;
};
/**
 * 取货点/门店列表
 * @param params
 * @returns {Promise<*>}
 */
export const queryPickList = async params => {
  const gql = `query pickList($query: FormQuery, $location: FormLocation) {
  pub {
    pickList(query: $query, location: $location) {
      data {
        pid
        name
        uid
        areaKey
        longitude
        latitude
        location
        applyTime
        applyTimeText
        createTime
        updateTime
        address
        contactName
        phone
        icon
        distance
      }
      meta {
        limit
        page
        count
        num
        skip
      }
    }
  }
}`;
  return (await Request.request(gql, params, 'mall', '取货点/门店列表')).pub.pickList;
};

/**
 * 新建秒杀资格
 * @param params
 * @returns {Promise<[]|*>}
 */
export const newFlash = async params => {
  const gql = `mutation newFlash($form: FormOrderBunch!) {
    meExec {
      newFlash(form: $form) {
        id
        aid
        theme
        createTime
        status
        uid
        xid
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '新建秒杀资格')).meExec.newFlash;
};

/**
 * 用户参加的活动
 * @param params
 * @returns {Promise<default.methods.newFlash>}
 */
export const userActivity = async params => {
  const gql = `query userActivity($id: String!) {
    me {
      userActivity(id: $id) {
        id
        uid
        aid
        xid
        theme
        status
        createTime
        updateTime
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '用户参加的活动')).me.userActivity;
};

// 商城
export const getStore = async params => {
  const gql = `query store($sid: String!) {
    pub {
      store(sid: $sid) {
        sid
        name
        icon
        description
        address
        phone
        numFans
        storeMeta {
          indexTheme
        }
      }
    }
  }`;
  return (await Request.request(gql, params, 'mall', '用户参加的活动')).pub.store;
};

/**
 * 取系统业务配置
 * @param params
 * @returns {Promise<*>}
 */
export const getSettingBusinessJson = async params => {
  const gql = `query getSettingBusinessJson {
    pub {
      getSettingBusinessJson
    }
  }`;
  return (await Request.request(gql, params, 'mall', '商城统业务配置')).pub.getSettingBusinessJson;
};
